<section>
    <div class="container-fluid">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item">Admin</li>
            <li class="breadcrumb-item active">Send Email</li>
        </ol>
    </div>
</section>
<section>
<button pButton pRipple type="button" label="Send Email" icon="pi pi-check"
    class="p-button-sm p-button-raised p-button-success m-2" disabled="true" (click)="SendEmail()"></button>
<button *ngIf="sharedService.checkPermission('Admin_Add')" pButton pRipple type="button" label="Add Requisition Due Expiry" icon="pi pi-check"
    class="p-button-sm p-button-raised p-button-success m-2" (click)="AddRequisition()" disabled="true"></button>
</section>
<div>
    <label>{{responsemessage}}</label>
</div>